<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button v-if="isAuth('finance:openingSupplier:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:openingSupplier:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="year" label="会计年度" width="100" align="center" />
      <el-table-column prop="partnerName" label="供应商名称" min-width="180">
        <template slot-scope="scope">
          <a v-if="isAuth('finance:openingSupplier:info') || isAuth('finance:openingSupplier:list')" class="code-link" @click="addOrUpdateHandle(scope.row.id, true)">{{ scope.row.partnerName }}</a>
          <span v-else>{{ scope.row.partnerName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="期初应付" width="140" align="right">
        <template slot-scope="scope">{{ money(scope.row.amount) }}</template>
      </el-table-column>
      <el-table-column prop="approveStatus" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审核</el-tag>
          <el-tag v-else type="info" size="small">未审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button v-if="isAuth('finance:openingSupplier:approve') && scope.row.approveStatus !== '2'" type="text" size="small" @click="approve(scope.row, true)">审核</el-button>
          <el-button v-if="isAuth('finance:openingSupplier:unapprove') && scope.row.approveStatus === '2'" type="text" size="small" @click="approve(scope.row, false)">弃审</el-button>
        </template>
      </el-table-column>
    </el-table>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import AddOrUpdate from './opening-supplier-add-or-update'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  mixins: [auth],
  components: { AddOrUpdate },
  data() {
    return { list: [], addOrUpdateVisible: false }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      request.get('/finance/doc/list', { params: { kind: 'openingSupplier' } }).then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, !!readonly))
    },
    approve(row, pass) {
      const url = pass ? '/finance/doc/approve' : '/finance/doc/unapprove'
      this.$confirm(pass ? '确定审核期初?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { kind: 'openingSupplier', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
</style>
